import type { IagoPortCapability } from 'common/models/iago-port-protocol';

let announced: ReadonlySet<string> = new Set();

// Wire boundary: a skewed/malformed shell must not be able to throw in the port
// message handler — accept only an array, keep only strings.
export function setAnnouncedIagoPortCapabilities(capabilities: unknown) {
  announced = new Set(
    Array.isArray(capabilities) ? capabilities.filter((c): c is string => typeof c === 'string') : [],
  );
}

export function resetAnnouncedIagoPortCapabilities() {
  announced = new Set();
}

export function hasIagoPortCapability(capability: IagoPortCapability): boolean {
  return announced.has(capability);
}
